export const HELP_CENTER_NAVIGATION_INTENTS = Object.freeze({
  portals_articles_index: 'SIDEBAR.HELP_CENTER.ARTICLES',
  portals_categories_index: 'SIDEBAR.HELP_CENTER.CATEGORIES',
  portals_locales_index: 'SIDEBAR.HELP_CENTER.LOCALES',
  portals_settings_index: 'SIDEBAR.HELP_CENTER.SETTINGS',
});

export const DEFAULT_HELP_CENTER_NAVIGATION_PATH = 'portals_articles_index';

export const isValidHelpCenterNavigationPath = navigationPath =>
  Object.prototype.hasOwnProperty.call(
    HELP_CENTER_NAVIGATION_INTENTS,
    navigationPath
  );

export const normalizeHelpCenterNavigationPath = navigationPath =>
  isValidHelpCenterNavigationPath(navigationPath)
    ? navigationPath
    : DEFAULT_HELP_CENTER_NAVIGATION_PATH;

export const helpCenterSetupIntentLabelKey = navigationPath =>
  HELP_CENTER_NAVIGATION_INTENTS[navigationPath] || null;

export const resolveHelpCenterSetupIntentLabel = (navigationPath, t) => {
  switch (navigationPath) {
    case 'portals_articles_index':
      return t('SIDEBAR.HELP_CENTER.ARTICLES');
    case 'portals_categories_index':
      return t('SIDEBAR.HELP_CENTER.CATEGORIES');
    case 'portals_locales_index':
      return t('SIDEBAR.HELP_CENTER.LOCALES');
    case 'portals_settings_index':
      return t('SIDEBAR.HELP_CENTER.SETTINGS');
    default:
      return '';
  }
};

export const helpCenterSetupIntentQuery = navigationPath => ({
  intendedNavigationPath: normalizeHelpCenterNavigationPath(navigationPath),
});

export const buildHelpCenterPortalRedirect = ({
  navigationPath,
  portalParams,
}) => {
  const normalizedNavigationPath =
    normalizeHelpCenterNavigationPath(navigationPath);

  if (portalParams) {
    return {
      name: normalizedNavigationPath,
      params: portalParams,
      replace: true,
    };
  }

  return {
    name: 'portals_new',
    params: {},
    query: helpCenterSetupIntentQuery(normalizedNavigationPath),
    replace: true,
  };
};
